export default {
  main:{ // 一级菜单
    sys_mng : {
      icon : "settings",
    },
    srv_om : {
      icon : "dns",
    },
    iot_mng : {
      icon : "devices",
    },
    app_mng : {
      icon : "apps",
    },
    clo_mng : {
      icon : "widgets",
    },
    push_mng : {
      icon : "trending_up",
    },
    vas: {
      custom: true,
      icon : "vas",
    },
  },
  sub:{ // 二级菜单
      order_mng_2      : "/vas/order",
      cloud_save_order : "/vas/cloud",
      iot_order_mng    : "/vas/iot",
      active_order     : "/vas/cdkorder",
      live_server      : "/vas/live_server",
      comm_mng         : "/vas/comm_mng",
      bill_mng         : "/user/bills",

      sys_role_mng_2   : "/system/role",
      menu_mng_2       : "/system/menu",
      server_mng       : "/operate/server",
      set_mng          : "/operate/setmng",
      srv_temp         : "/operate/settemp",
      sys_push_conf    : "/operate/pushconf",
      consul           : "/operate/consul",
      zone_bind        : "/operate/zone",
      iccid_mng        : "/product/iccid",
      active_code      : "/product/actcode",
      dev_details      : "/product/device",
      refund           : "/product/refund",
      device_awake     : "/product/awake",
      device_state     : "/product/device_state",
      product_list     : "/product/product_list",
      dev_dup          : "/product/dev_dup",
      app_mng_2        : "/applist/app",
      p_flatform_mng   : "/applist/flatform",
      p_template_mng   : "/applist/template",
      record_info      : "/applist/record",
      pay_mod_mng      : "/operate/payment",
      time_plan        : "/operate/time_plan",
      clo_mng_2        : "/operate/cloud",
      other_platform   : "/operate/platform",
      com_mng_2        : "/operate/company",
      user_mng_2       : "/operate/user",
      shop_2           : "/operate/shop",
      good_1           : "/operate/good",
      customer_service : "/operate/service",
      bot_mng          : "/operate/bot",
      ip_server        : "/operate/ipserver",
      sys_not_mng      : "/operate/sysnotimng",
      que_feed         : "/operate/quefeed",
      order_statis     : "/info/order",
      user_statis      : "/info/user",
      dev_statis       : "/info/dev",
      app_user         : "/applist/user",
      app_dev          : "/applist/dev",
      res_man          : "/system/resource",
      user_notice_temp : "/applist/notice_template",
      msg_mng          : "/applist/msg_mng",
      log_list         : "/applist/log_list",
      alarm_list       : "/applist/alarm",
      lic_list         : "/product/lic_list",
      lic_auth         : "/product/lic_auth",
      adv_pla_mng      : "/operate/advplamng",
      uid_auth_02      : "/product/uid_auth",
      wit_acc          : "/vas/with_acc",
      inv_mng          : "/vas/inv_mng",
      wit_his          : "/vas/wit_his",
      with_app         : "/vas/wit_app",
  },
}